<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="600px"
    title="审核意见"
    :close-on-click-modal="false"
  >
    <el-form label-width="85px">
      <el-form-item label="审核意见">
        <el-input
          v-model="auditText"
          type="textarea"
          placeholder="请输入审核意见"
          :autosize="{ minRows: 4, maxRows: 4 }"
          maxlength="500"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="submitArea">
      <el-button type="primary" @click="handleConfirm">确定</el-button>
      <el-button plain @click="dialogVisible = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "KdAuditPassDialog",
  props: {
    visible: Boolean,
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      auditText: ""
    };
  },
  computed: {
    dialogVisible: {
      get() { return this.visible; },
      set(val) { this.$emit("update:visible", val); }
    }
  },
  watch: {
    visible(val) {
      if (val) this.auditText = this.value;
    }
  },
  methods: {
    handleConfirm() {
      this.$emit("confirm", this.auditText);
      this.$emit("input", this.auditText);
      this.dialogVisible = false;
    }
  }
};
</script>

<style scoped>
.submitArea {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}
</style>
